export default __webpack_public_path__ + "static/media/linkedin.3961327d.svg";